module.exports = __webpack_public_path__ + "static/media/571.02450df7.webp";